import React, { useRef, useEffect, useCallback, useState} from 'react';
import {setContextualHelp} from 'actions/index.js';
import {BPM_SLIDER} from 'constants/contextual-help.js';
import {sleep} from 'utils/sleep.js';
import {connect} from 'react-redux';

const DOUBLE_CLICK_TIME = 250;

const BPMComponent = ({bpm, sequencerEngine, setContextualHelp}) => { 
    let [yPosition, setYPosition] = useState(0);
    let [editing, setEditing] = useState(false);
    let [bpmValue, setBpmValue] = useState(bpm);
    let changing = useRef(false);
    let dist = useRef(0);
    let lastClick = useRef(0);

    const onMouseDown = useCallback(async (e) => {
        let date = new Date().getTime();
        if (date - lastClick.current <= DOUBLE_CLICK_TIME) {
            setEditing(true);
            return;
        }
        lastClick.current = date;

        let y = e.clientY;
        setYPosition(y);
        dist.current = 0;
        changing.current = true;

        while (changing.current) {
            let d = dist.current;
            sequencerEngine.bpm = Math.round(sequencerEngine.bpmParameter.get() - d / 5.0);
            await sleep(50);
        }

    }, [setYPosition, setEditing]);

    const onMouseUp = useCallback((e) => {
        changing.current = false;
        setContextualHelp(undefined);
    }, []);

    const onMouseMove = useCallback((e) => {
        if (changing.current) {
            dist.current = e.clientY - yPosition;
        }
    }, [yPosition]);

    let rounded = Math.round(bpm*10) / 10;

    const onChange = useCallback((e) => {
        let text = e.target.value;
        setBpmValue(text);
        if (parseFloat(text)) {
            sequencerEngine.bpm = parseFloat(text);
        }
    }, [sequencerEngine, setBpmValue]);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            setEditing(false);
        }
    }, [setEditing]);

    return (
        <div
          onMouseOver={() => setContextualHelp(BPM_SLIDER)}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          onMouseLeave={onMouseUp}
          onMouseMove={onMouseMove}
          className="bpm-component">
          {editing ?
           <input
             onKeyDown={onKeyDown}
             onChange={onChange}
             value={bpmValue}
             type="text"
             className="bpm-input"/> :
         rounded}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      bpm: props.sequencerEngine.bpmParameter.get()
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setContextualHelp: (x) => dispatch(setContextualHelp(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BPMComponent);
